module.exports = __webpack_public_path__ + "img/type-tel.226efee6.png";